import { lazy } from "react";

import ApiDetails from "./pages/api-details";

const Home = lazy(() => import("@/pages/index"));
const AboutUs = lazy(() => import("@/pages/about-us"));
const Products = lazy(() => import("@/pages/products"));
const ProductDetails = lazy(() => import("@/pages/product-details"));
const CaseStudies = lazy(() => import("@/pages/case-studies"));
const CaseStudiesDetails = lazy(() => import("@/pages/case-studies-details"));
const Insights = lazy(() => import("@/pages/insights"));
const OurTeam = lazy(() => import("@/pages/our-team"));
const Contact = lazy(() => import("@/pages/contact"));
const InsightsDetails = lazy(() => import("@/pages/insights-details"));
const Services = lazy(() => import("@/pages/services"));
const PrivacyPolicy = lazy(() => import("@/pages/privacy-policy"));
const PrivacyPolicyS = lazy(() => import("@/pages/privacy-plc"));
const Careers = lazy(() => import("@/pages/career"));
const Jobs = lazy(() => import("@/pages/jobs"));
const JobDetails = lazy(() => import("@/pages/job-details"));
const ApplyJob = lazy(() => import("@/pages/apply-job"));
const FAQ = lazy(() => import("@/pages/faq"));
const AI = lazy(() => import("@/pages/ai"));
const Checkout = lazy(() => import("@/pages/checkout"));
const RefundPolicy = lazy(() => import("@/pages/refund-policy"));
const NotFound = lazy(() => import("@/pages/not-found"));

const router = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/about-us",
    component: AboutUs,
  },
  {
    path: "/products",
    component: Products,
  },
  {
    path: "/products/:slug",
    component: ProductDetails,
  },
  {
    path: "/case-studies",
    component: CaseStudies,
  },
  {
    path: "/case-studies/:id",
    component: CaseStudiesDetails,
  },
  {
    path: "/insights",
    component: Insights,
  },
  {
    path: "/insights/:id",
    component: InsightsDetails,
  },
  {
    path: "/services/:slug",
    component: Services,
  },
  {
    path: "/our-team",
    component: OurTeam,
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "/refund-policy",
    component: RefundPolicy,
  },
  {
    path: "/privacy-policy-attendx",
    component: PrivacyPolicyS,
  },
  {
    path: "/career",
    component: Careers,
  },
  {
    path: "/career/jobs",
    component: Jobs,
  },
  {
    path: "/career/jobs/:slug",
    component: JobDetails,
  },
  {
    path: "/career/jobs/:slug/apply",
    component: ApplyJob,
  },
  {
    path: "/contact",
    component: Contact,
  },
  {
    path: "/frequently-asked-questions",
    component: FAQ,
  },
  {
    path: "/ai",
    component: AI,
  },
  {
    path: "/ai/api/:id",
    component: ApiDetails,
  },
  {
    path: "/ai/checkout",
    component: Checkout,
  },
  {
    path: "*",
    component: NotFound,
  },
];

export default router;
